export const SIGN_OUT_PATH = '/auth/signout';
